import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@docplugin/core';
import { App } from './App';
import type { ViewId } from './App';

Office.onReady(() => {
  const params = new URLSearchParams(window.location.search);
  const initialView = (params.get('view') || 'placeholders') as ViewId;

  const root = createRoot(document.getElementById('root')!);
  root.render(
    <ThemeProvider>
      <App initialView={initialView} />
    </ThemeProvider>,
  );
});
